import { render, staticRenderFns } from "./TablePengajuan.vue?vue&type=template&id=926b34b2"
import script from "./TablePengajuan.vue?vue&type=script&lang=js"
export * from "./TablePengajuan.vue?vue&type=script&lang=js"
import style0 from "./TablePengajuan.vue?vue&type=style&index=0&id=926b34b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports